import { render, staticRenderFns } from "./GetRole.vue?vue&type=template&id=027bf1b1&"
import script from "./GetRole.vue?vue&type=script&lang=js&"
export * from "./GetRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports